export function searchFormView() {
  const headerTopSearchEle = document.querySelector('.js-headerTopSearch');
  const headerTopSearchBoxEle = document.querySelector('.js-headerTopSearchBox');
  const IS_VIEW = 'is-view';

  headerTopSearchEle.addEventListener('click', () => {
    headerTopSearchBoxEle.classList.add(IS_VIEW);
  });

  // headerTopSearchEle.addEventListener('blur', () => {
  //   headerTopSearchBoxEle.classList.remove(IS_VIEW);
  // });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.js-headerTopSearch')) {
      //ここに外側をクリックしたときの処理
      headerTopSearchBoxEle.classList.remove(IS_VIEW);
    } else {
      //ここに内側をクリックしたときの処理
    }
  });
}
